

import { dateService } from "../../services/date.service";
import { staffService } from "../../services/staff.service";
import { taskService } from '../../services/task.service';
import { trackService } from '../../services/track.services';
import { STORE_CONSTANTS } from '../../common/store.constants';

const MUTATION_NAMES = STORE_CONSTANTS.STUDY.MUTATIONS.WITHOUT_NAMESPACE;


const study = {
    namespaced: true,
    actions: {
        setSelectedStudy(context, studyId) {
            return new Promise((resolve, reject) => {

                context.commit(MUTATION_NAMES.SET_SELECTED_STUDY_ID, studyId);

                let staff = [];
                staffService.getAllStaffNames({ study: studyId }).then(function (response) {
                  if (response && response.data) {
                    staff = response.data;
                  }

                  context.commit('dailyTasks/clearStaffDailyInfo', {}, { root:true });
                  context.commit('tracks/clearAllTracks', {}, { root:true });
                  context.commit(MUTATION_NAMES.SET_SELECTED_STUDY_STAFF, staff);

                  // Build a map of staff ID -> staff object 
                  const staffMap = {};
                  for(let staffMember of staff) {
                    const key = (staffMember.staffId) ? staffMember.staffId : staffMember.nameFull;
                    staffMap[key] = staffMember;
                  }
                  context.commit(MUTATION_NAMES.SET_SELECTED_STUDY_STAFF_MAP, staffMap);                  

                  resolve({ staff: staff });
                })
                .catch(function (err) {
                  reject(err);
                });
            });
        },
        loadStudyTaskCounts(context, criteria) {
            return new Promise((mainResolve, mainReject) => {
                const studyId = context.state.selectedStudyId;

                // Suspect, In Review, & No Data
                let taskCountPromise = new Promise ((resolve, reject) => {
                    taskService.getTaskCounts(criteria).then(function (response) {
                        if (response && response.data) {
                            let taskCounts = {
                                suspect: response.data.SUSPECT,
                                under_review: response.data.UNDER_REVIEW,
                                no_data: response.data.NO_DATA
                            };
                            context.commit(MUTATION_NAMES.SET_STUDY_TASK_COUNTS, taskCounts);
                            resolve({ taskCounts: taskCounts});
                        }
                    })
                    .catch(function (err) {
                        reject(err);
                    });
                });

                let yesterday = dateService.getYesterday();
                let dashboardCriteria = {
                  study: studyId,
                  startdate: yesterday,
                  enddate: yesterday,
                };

                // Valid : this should work to get a Valid percentage, but the API doesn't return it
                let taskPctPromise = new Promise ((resolve, reject) => {
                    taskService.getTaskPercentages(dashboardCriteria).then(function (response) {
                        let pct = '0%';
                        if (response && response.data && response.data.VALID) {
                            pct = response.data.VALID.toFixed(1) + "%";
                        }
                        context.commit(MUTATION_NAMES.SET_STUDY_TASK_PERCENT, pct);
                        resolve({ taskPct:  pct});
                    }).catch(function (err) {
                        reject(err);
                    });
                });

                // gps data
                let gpsDataPromise = new Promise ((resolve, reject) => {
                    trackService.getTrackCounts(dashboardCriteria).then(function (response) {
                        let gpsData;
                        if (response && response.data) {
                            gpsData = response.data.LAPTOP + response.data.PHONE
                        }

                        context.commit(MUTATION_NAMES.SET_STUDY_GPS_DATA, gpsData);
                        resolve({ gpsData:  gpsData});
                    })
                    .catch(function (err) {
                        reject(err);
                    });
                });


                Promise.all([taskCountPromise, taskPctPromise, gpsDataPromise]).then((values) => {
                    mainResolve({
                        taskCounts: values[0].taskCounts,
                        taskPct: values[1].taskPct,
                        gpsData: values[2].gpsData
                    });
                })
                .catch((err) => {
                    console.error(err);
                    mainReject(err);
                });
            });
        }
    },
    getters: {
        getSelectedStudyId: (state) => {
            return state.selectedStudyId;
        },
        getSelectedStudyStaff: (state) => {
            return state.selectedStudyStaff;
        },
        /**
         * Returns a map of staff ID -> staff object map
         * @param {*} state 
         * @returns 
         */
        getSelectedStudyStaffMap: (state) => {
            return state.selectedStudyStaffMap;
        }
    },
    mutations: {
			setSelectedStudyId(state, studyId) {
					// Make sure the studyId is not null
                    if(studyId) {
                        state.selectedStudyId = studyId;
                        sessionStorage.setItem('selectedStudy', studyId);
                    }					
			},
			setSelectedStudyStaff(state, studyStaff) {
					state.selectedStudyStaff = studyStaff;
			},
            /**
             * Sets staff ID -> staff object map.
             * @param {*} state 
             * @param {*} studyStaffMap 
             */
            setSelectedStudyStaffMap(state, studyStaffMap) {
                state.selectedStudyStaffMap = studyStaffMap;
            },
			setStudyTaskCounts(state, taskCounts) {					
					state.studyTaskCounts = taskCounts;
			},
			setStudyTaskPercent(state, studyTaskPct) {
					state.studyTaskPercent = studyTaskPct;
			},
			setStudyGpsData(state, studyGpsData) {
					state.studyGpsData = studyGpsData;
			}
	},
    state: {
        selectedStudyId: null,
        selectedStudyStaff: null,
        selectedStudyStaffMap: {},
        selectedStudyInfo: null,
        studyTaskCounts: {
            suspect: 0,
            under_review: 0,
            no_data: 0
        },
        studyTaskPercent: '0%',
        studyGpsData: null,
        uiComponentInfo: {}
    }
};

export default study;
